/**
 * Lookbook Card Interactive Functionality
 * Handles overlay show/hide and add-to-cart actions
 */

(function() {
  'use strict';

  function initLookbookCards() {
    const cards = document.querySelectorAll('[data-lookbook-card]');

    if (cards.length === 0) {
      return;
    }

    cards.forEach(function(card) {
      const trigger = card.querySelector('[data-lookbook-trigger]');
      const overlay = card.querySelector('[data-lookbook-overlay]');
      const closeButton = card.querySelector('[data-lookbook-close]');

      if (!trigger || !overlay) {
        return;
      }

      // Open overlay on button click
      trigger.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        // Close any other open overlays
        document.querySelectorAll('[data-lookbook-overlay]').forEach(function(otherOverlay) {
          if (otherOverlay !== overlay) {
            otherOverlay.setAttribute('hidden', '');
          }
        });

        // Show this overlay
        overlay.removeAttribute('hidden');

        // Focus close button
        if (closeButton) {
          setTimeout(function() {
            closeButton.focus();
          }, 100);
        }
      });

      // Close overlay on close button click
      if (closeButton) {
        closeButton.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          overlay.setAttribute('hidden', '');
          trigger.focus();
        });
      }

      // Close overlay on Escape key
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && !overlay.hasAttribute('hidden')) {
          overlay.setAttribute('hidden', '');
          trigger.focus();
        }
      });

      // Handle add to cart forms
      const forms = card.querySelectorAll('[data-product-form]');
      forms.forEach(function(form) {
        form.addEventListener('submit', function(e) {
          e.preventDefault();

          const submitButton = form.querySelector('button[type="submit"]');
          const formData = new FormData(form);

          // Show loading state
          submitButton.disabled = true;
          submitButton.classList.add('is-loading');

          // Add to cart via Shopify AJAX API
          fetch('/cart/add.js', {
            method: 'POST',
            body: formData
          })
          .then(function(response) {
            return response.json();
          })
          .then(function(data) {
            console.log('Added to cart:', data);

            // Show success feedback
            const originalText = submitButton.textContent;
            submitButton.textContent = 'Added!';
            submitButton.style.backgroundColor = 'rgb(34, 197, 94)';

            // Update cart count
            updateCartCount();

            // Try to open cart drawer
            document.dispatchEvent(new CustomEvent('cart:refresh'));

            setTimeout(function() {
              submitButton.textContent = originalText;
              submitButton.style.backgroundColor = '';
              submitButton.disabled = false;
              submitButton.classList.remove('is-loading');
            }, 2000);
          })
          .catch(function(error) {
            console.error('Error adding to cart:', error);

            // Show error feedback
            const originalText = submitButton.textContent;
            submitButton.textContent = 'Error';
            submitButton.style.backgroundColor = 'rgb(239, 68, 68)';

            setTimeout(function() {
              submitButton.textContent = originalText;
              submitButton.style.backgroundColor = '';
              submitButton.disabled = false;
              submitButton.classList.remove('is-loading');
            }, 2000);
          });
        });
      });
    });
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(function(response) {
        return response.json();
      })
      .then(function(cart) {
        const cartCountElements = document.querySelectorAll(
          '[data-cart-count], .cart-count, .cart-count-bubble'
        );

        cartCountElements.forEach(function(element) {
          element.textContent = cart.item_count;
          if (cart.item_count > 0) {
            element.classList.remove('hidden');
          }
        });
      })
      .catch(function(error) {
        console.error('Error updating cart count:', error);
      });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLookbookCards);
  } else {
    initLookbookCards();
  }

  // Re-initialize on AJAX page changes
  document.addEventListener('shopify:section:load', initLookbookCards);

  // Store the scroll position before locking
  var scrollPosition = 0;

  // Helper function to lock scroll on mobile
  function lockScroll() {
    // Only lock on mobile (max-width: 740px)
    if (window.innerWidth <= 740) {
      // Save current scroll position
      scrollPosition = window.pageYOffset || document.documentElement.scrollTop;

      // Lock the body in place
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + scrollPosition + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
    }
  }

  // Helper function to unlock scroll on mobile
  function unlockScroll() {
    if (window.innerWidth <= 740) {
      // Remove fixed positioning
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';

      // Restore scroll position
      window.scrollTo(0, scrollPosition);
    }
  }

  // Use event delegation on document level
  // This works even if elements are added dynamically
  document.addEventListener('click', function(e) {
    const trigger = e.target.closest('[data-lookbook-trigger]');

    if (trigger) {
      e.preventDefault();
      e.stopPropagation();

      const row = trigger.closest('[data-lookbook-row]');
      if (!row) return;

      const overlay = row.querySelector('[data-lookbook-overlay]');
      if (!overlay) return;

      // Close any other open overlays
      document.querySelectorAll('[data-lookbook-overlay]').forEach(function(otherOverlay) {
        if (otherOverlay !== overlay) {
          otherOverlay.setAttribute('hidden', '');
        }
      });

      // Show this overlay
      overlay.removeAttribute('hidden');

      // Lock scroll on mobile
      lockScroll();

      // Focus close button
      const closeButton = overlay.querySelector('[data-lookbook-close]');
      if (closeButton) {
        setTimeout(function() {
          closeButton.focus();
        }, 100);
      }
    }

    // Handle close button
    const closeBtn = e.target.closest('[data-lookbook-close]');
    if (closeBtn) {
      e.preventDefault();
      e.stopPropagation();

      const row = closeBtn.closest('[data-lookbook-row]');
      const overlay = row.querySelector('[data-lookbook-overlay]');
      const trigger = row.querySelector('[data-lookbook-trigger]');

      if (overlay) {
        overlay.setAttribute('hidden', '');
      }

      // Unlock scroll on mobile
      unlockScroll();

      if (trigger) {
        trigger.focus();
      }
    }
  });

  // Close on Escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      const openOverlay = document.querySelector('[data-lookbook-overlay]:not([hidden])');
      if (openOverlay) {
        openOverlay.setAttribute('hidden', '');

        // Unlock scroll on mobile
        unlockScroll();

        // Return focus to trigger button
        const row = openOverlay.closest('[data-lookbook-row]');
        if (row) {
          const trigger = row.querySelector('[data-lookbook-trigger]');
          if (trigger) {
            trigger.focus();
          }
        }
      }
    }
  });

})();
